import superAdminRoutes from "./SuperAdmin";

const superAdminRouteMap = {
  ...superAdminRoutes
};
export default superAdminRouteMap;
